export const SECURITY_INSERT = "SECURITY_INSERT";
export const DEVICE_REMOVE = "DEVICE_REMOVE";
export const PRIMARY_DEVICE = "PRIMARY_DEVICE";
